/**
 * Backend API origin baked in at build time. Production Pages builds must set
 * VITE_API_BASE_URL (vite.config.ts hard-fails otherwise); an empty base is
 * only valid behind the local Vite proxy / SQLite demo.
 */
function resolveApiBaseUrl(): string {
  const fromEnv = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  return (fromEnv ?? "").replace(/\/+$/, "");
}

export const API_BASE_URL: string = resolveApiBaseUrl();
